var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCrossCircle = function SvgCrossCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_261",
    "data-name": "Group 261",
    transform: "translate(-1282 -371)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outline",
    transform: "translate(1267.5 356.911)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4",
    "data-name": "Ellipse 4",
    cx: 8,
    cy: 8,
    r: 8,
    transform: "translate(15.5 15.089)",
    strokeWidth: 2,
    stroke: "#f1373d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_60",
    "data-name": "Line 60",
    x2: 5.499,
    y2: 5.499,
    transform: "translate(1288.25 377.576)",
    fill: "none",
    stroke: "#f1373d",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_61",
    "data-name": "Line 61",
    x1: 5.499,
    y2: 5.499,
    transform: "translate(1288.25 377.576)",
    fill: "none",
    stroke: "#f1373d",
    strokeLinecap: "round",
    strokeWidth: 2
  }))));
};
export default SvgCrossCircle;